import { useQuery } from 'react-query'
import { api } from '../../../../services/api'
import { useUser } from '../../../../hooks/useUser'

export function usePedidos(filtros = {}) {
  const { codigo_usuario } = useUser() // Obtendo o código do usuário

  const buildQueryParams = (filtros) => {
    const params = new URLSearchParams()

    // Adicionar filtros se existirem
    if (filtros.numeroPedido) params.append('codigo', filtros.numeroPedido)
    if (filtros.dataInicio) params.append('data_inicio', formatDateToAPI(filtros.dataInicio))
    if (filtros.dataFim) params.append('data_fim', formatDateToAPI(filtros.dataFim))
    if (filtros.statusPagamento) params.append('status_pagamento', filtros.statusPagamento)

    return params.toString()
  }

  const formatDateToAPI = (dateString) => {
    if (!dateString) return ''
    return dateString
  }

  const fetchPedidos = async () => {
    const queryString = buildQueryParams(filtros)
    // Construir a URL com a query string
    const url = `/site/v2/tercerizado/lista-pendencias-pagamento-tercerizado${queryString ? `?${queryString}` : ''}`

    const response = await api.get(url)

    return response.data.map(formatPedido)
  }

  const formatPedido = (pedido) => {
    return {
      id: pedido.id_pedido, // Usando o id_pedido fornecido pela API
      pedidoNumero: pedido.pedido?.toString() || '',
      data: formatarDataHora(pedido.data_entrada),
      pedido: pedido.pedido?.toString() || '',
      dataAprovacao: formatarDataHora(pedido.data_aprovacao),
      codigoProduto: (pedido.codigo_produto || 0).toString(),
      produto: pedido.nome_produto || '',
      cor: pedido.cor_produto || '',
      gravacao: pedido.gravacao || '',
      recebimento: formatarDataHora(pedido.data_aprovacao), // Usando a data de aprovação como recebimento
      observacao: pedido.observacao || '',
      prazo: pedido.prazo || 10,
      pago: pedido.status_pagamento === 'Pago',
      statusPagamento: pedido.status_pagamento || 'Pendente',
      quantidade: pedido.quantidade || '0',
    }
  }

  return useQuery(['@pedidos-pagamentos', filtros], fetchPedidos, {
    staleTime: 1000 * 60 * 5, // 5 minutos
    refetchOnWindowFocus: false,
    retry: 2,
    keepPreviousData: true,
  })
}

function formatarDataHora(dataString) {
  if (!dataString) return ''

  try {
    const [dataParte, horaParte] = dataString.split(' ')
    if (!dataParte) return dataString

    const [ano, mes, dia] = dataParte.split('-')
    const hora = horaParte ? horaParte.split('.')[0] : ''

    return `${dia}/${mes}/${ano} ${hora}`
  } catch (error) {
    console.error('Erro ao formatar data:', error)
    return dataString
  }
}
